import customAxios from "./axiosConfig";

const formatAddress = function(addressData) { // returns the location name if not set
    if (addressData.name) {
        if (addressData.name.length)
            return addressData.name;
    }

    var formatted_address = "";

    if (addressData.street){
        formatted_address += addressData.street + " ";
    }
    if (addressData.number){
        formatted_address += addressData.number + ", ";
    }
    if (addressData.postcode){
        formatted_address += addressData.postcode + ", ";
    }
    if (addressData.city){
        formatted_address += addressData.city + ", ";
    }
    if (addressData.country){
        formatted_address += addressData.country_display;
    }
    if (!formatted_address && addressData.latitude && addressData.longitude){
        formatted_address += addressData.latitude +", "+ addressData.longitude;
    }

    return formatted_address;
}

const TripService = {
    list: function(params) {
        var api_url = window.Urls['trip-list']();
        const promise = customAxios.get(api_url, {params: params});
        return promise.then(function (response) {
            response.data = response.data.map(trip => {
                trip.start.name = formatAddress(trip.start);
                trip.end.name = formatAddress(trip.end);
                return trip;
            });
            return response;
        });
    },
    listPaginated: function(params) {
        var api_url = window.Urls['v3:trip-list']();
        const promise = customAxios.get(api_url, {params: params});
        return promise.then(function(response) {
            response.data.results = response.data.results.map(trip => {
                trip.start.name = formatAddress(trip.start);
                trip.end.name = formatAddress(trip.end);
                return trip;
            });
            return response;
        });
    },
    listNextPage: function(next_url) {
        const promise = customAxios.get(next_url);
        return promise.then(function(response) {
            response.data.results = response.data.results.map(trip => {
                trip.start.name = formatAddress(trip.start);
                trip.end.name = formatAddress(trip.end);
                return trip;
            });
            return response;
        });
    },
    customerList: function (params) {
        var api_url = window.Urls["trip_customer_list"]();
        return customAxios.get(api_url, { useCache: params?.useCache, params: params })
    },
    getTotals: function(params){
        var api_url = window.Urls['trip-totals']()
        return customAxios.get(api_url, {params: params});
    },
    retrieve: function(pk, params) {
        var api_url = window.Urls['trip-detail'](pk);
        const promise = customAxios.get(api_url, {params: params});
        return promise.then(function (response) {
            response.data.start.name = formatAddress(response.data.start);
            response.data.end.name = formatAddress(response.data.end);
            return response;
        });
    },
    create: function(data) {
        var api_url = window.Urls['trip-list']();
        return customAxios.post(api_url, data);
    },
    update: function(pk, data) {
        var api_url = window.Urls['trip-detail'](pk);
        return customAxios.put(api_url, data);
    },
    destroy: function(pk) {
        var api_url = window.Urls['trip-detail'](pk);
        return customAxios.delete(api_url);
    },
    getLast: function(params) {
        var api_url = window.Urls['v3:trip-get-last']();
        return customAxios.get(api_url, {params: params});
    },
    getNextTripNumber: function(company_profile_id, data) {
        var api_url = window.Urls['trip-next-trip-number'](company_profile_id);
        return customAxios.post(api_url, data);
    },
    getRoute(id) {
        return customAxios.get(window.Urls['trip-get-route'](id));
    },
    getDirections(params) {
        const g = window.google
        if (!g || !g.maps || !g.maps.DirectionsService) {
            throw new Error('Google Maps JS API not loaded (DirectionsService unavailable)')
        }
        const directionsService = new g.maps.DirectionsService()
        return directionsService.route(params)
    },
    calculatePolyline(route) {
        const g = window.google
        const decoder = g && g.maps && g.maps.geometry && g.maps.geometry.encoding

        if (!decoder || !decoder.decodePath) return []
        if (!route) return []

        return decoder.decodePath(route)
    },
    getTotalKmBusiness: function(params){
        var api_url = window.Urls['trip-total-business']()
        return customAxios.get(api_url, {params: params});
    },
    getTotalKmPrivate: function(params){
        var api_url = window.Urls['trip-total-private']()
        return customAxios.get(api_url, {params: params});
    },
    exportTrips: function(params) {
        var api_url = window.Urls['trip-export-trips']();
        return customAxios.get(api_url, {params: params});
    },
    activeYears: function (params) {
        var api_url = window.Urls["trip-years"]();
        return customAxios.get(api_url, {params: params});
    },    
}

export default TripService;